import {AppointmentTypeService} from "./service/api/appointment-type.service";
import {ScheduleTypeService} from "./service/api/schedule-type.service";
import {MsCalendarTypeService} from "./service/api/ms-calendar-type.service";
import {AppointmentService} from "./service/api/appointment.service";
import {MsBookingTypeService} from "./service/api/ms-booking-type.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {
    AsAppointmentEventComponent
} from "./component/protected-components/as-appointment-event/as-appointment-event.component";
import {AsMsEventComponent} from "./component/protected-components/as-ms-event/as-ms-event.component";

export const AS_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['as.AppointmentGroup', {route: '/as/appointmentGroups'}],
            ['as.AppointmentResultType', {route: '/as/appointmentResultTypes'}],
            ['as.AppointmentReasonType', {route: '/as/appointmentReasonTypes'}],
            ['as.AppointmentType', {route: '/as/appointmentTypes', service: AppointmentTypeService}],
            ['as.AppointmentTypeScheduleType', {
                route: '/as/appointmentTypeScheduleTypes'
            }],
            ['as.ScheduleType', {route: '/as/scheduleTypes', service: ScheduleTypeService}],
            ['as.MsCalendarType', {route: '/as/msCalendarTypes', service: MsCalendarTypeService, objectComponent: [{component: AsMsEventComponent}]}],
            ['as.MsBooking', {route: '/as/msBookings'}],
            ['as.AppointmentParticipantAgent', {route: '/as/appointmentParticipantAgents'}],
            ['as.Appointment', {route: '/as/appointments', service: AppointmentService, objectComponent: [{component: AsAppointmentEventComponent}]}],
            ['as.AppointmentParticipantCustomer', {route: '/as/appointmentParticipantCustomers'}],
            ['as.AppointmentParticipantLead', {route: '/as/appointmentParticipantLeads'}],
            ['as.MsBookingType', {route: '/as/msBookingTypes', service: MsBookingTypeService}],
            ['as.AppointmentTypeAgent', {route: '/as/appointmentTypeAgents'}],
            ['as.AppointmentTypeAgentPool', {route: '/as/appointmentTypeAgentPools'}],
            ['as.MsSubscription', {route: '/as/msSubscriptions'}],
            ['as.MsSubscriptionType', {route: '/as/msSubscriptionTypes'}],

            ['as.MsDeltaQuery', {route: '/as/msDeltaQuerys'}],
            ['as.MsCloudEvent', {route: '/as/msCloudEvents'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
